import React, { useEffect, useState } from "react";
import utils from "../../Utils";
import "./tableFilter.css";
import strings from "../../Utils/strings";
import classNames from "classnames";
import { t } from "../../Utils/translate";

function TableFilter({
    list,
    buttonActive,
    onCheckboxClick,
    onCancelClick,
    onOkClick,
    okClassName,
    cancelClassName,
    checkboxClassName,
    colorTheme,
}) {
    const [checkboxList, setCheckboxList] = useState([]);
    const [btnVisible, setBTNVisible] = useState(true);

    useEffect(() => {
        setCheckboxList(list);
        if (buttonActive) {
            setBTNVisible(buttonActive);
        }
    }, [list]);

    function onCheckboxClickFun(index) {
        let arr = [...checkboxList];
        arr[index].status = !arr[index].status;
        if (arr[index].allType) {
            for (let i in arr) {
                arr[i].status = arr[index].status;
            }
        } else {
            let isAll = true;
            for (let i in arr) {
                if (!arr[i].allType && !arr[i].status) {
                    isAll = false;
                    break;
                }
            }
            if (isAll) {
                for (let i in arr) {
                    if (arr[i].allType) {
                        arr[i].status = true;
                        break;
                    }
                }
            } else {
                for (let i in arr) {
                    if (arr[i].allType) {
                        arr[i].status = false;
                        break;
                    }
                }
            }
        }

        let count = 0;

        arr.map((item, i) => {
            if (item.status && !item.allType) {
                count += 1;
            }
        });

        if (count === arr.length - 1) {
            arr.map((item, i) => {
                if (item.allType) {
                    arr[i].status = true;
                }
            });
        }

        setCheckboxList([...arr]);
        if (onCheckboxClick) {
            onCheckboxClick(arr);
        }
    }

    function renderCheckbox(item, i) {
        return (
            <div className="checkbox-view" key={i}>
                <input
                    type="checkbox"
                    className={classNames(
                        checkboxClassName
                            ? checkboxClassName
                            : colorTheme
                                ? colorTheme
                                : "appointment-request-checkbox"
                    )}
                    checked={item.status}
                    onChange={() => {
                        onCheckboxClickFun(i);
                    }}
                />
                <div className="checkbox-label">{item.label}</div>
            </div>
        );
    }

    return (
        <div className="table-filter">
            <div className={"table-body"}>
                {checkboxList.map((item, i) => {
                    return onOkClick ? renderCheckbox(item, i) : item;
                })}
            </div>
            {btnVisible ? (
                <div className="table-filter-btn-view custom-btn-cancel">
                    <button
                        className={classNames(
                            cancelClassName
                                ? cancelClassName
                                : colorTheme
                                    ? colorTheme
                                    : "table-filter-btn cancel-btn"
                        )}
                        onClick={() => {
                            if (onCancelClick) {
                                onCancelClick(checkboxList);
                            }
                        }}
                    >
                        {t("btnCancel")}
                    </button>
                    <button
                        className={classNames(
                            okClassName
                                ? okClassName
                                : colorTheme
                                    ? colorTheme
                                    : "table-filter-btn ok-btn"
                        )}
                        onClick={() => {
                            if (onOkClick) {
                                onOkClick(checkboxList);
                            }
                        }}
                    >
                        {t("btnOkay")}
                    </button>
                </div>
            )
                :
                null
            }
        </div>
    )
        ;
}

export default TableFilter;
